import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { labelClassName } from '@fluentui/react-northstar';

export const ArticleAuthBannerContainer: StyleRule = ({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',

    padding: 0,

    borderTop: `1px solid ${theme.siteVariables.colors.primitive.black}`,

    [theme.screen.laptop]: {
        padding: pxArrayToRem([30, 44, 35, 44]),
        borderTop: 'unset',
    },
});

export const ArticleAuthBannerContentContainer: StyleRule = ({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',

    backgroundColor: theme.siteVariables.colors.white['FFF'],
    padding: pxArrayToRem([51, 0, 54, 0]),

    [theme.screen.laptop]: {
        backgroundColor: '#E3E2E0',
        padding: pxArrayToRem([97, 0, 101, 0]),
    },
});

export const ArticleAuthBannerText: StyleRule = ({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    padding: pxArrayToRem([0, 93]),

    ...theme.siteVariables.textStyles.GTAmericaTrialFont.Light45,
    fontSize: pxToRem(20),
    fontWeight: 400,
    lineHeight: 1,
    letterSpacing: '-0.008em',

    [theme.screen.laptop]: {
        padding: 0,

        ...theme.siteVariables.textStyles.GTAmericaTrialFont.Bold75,
        fontSize: pxToRem(32),
        textTransform: 'uppercase',
    },
});

export const ArticleAuthBannerButtonGroup: StyleRule = ({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',

    marginTop: pxToRem(28),

    [`& .${buttonClassName}`]: {
        padding: pxArrayToRem([13, 19, 13, 22]),

        [`& .${labelClassName}`]: {
            ...theme.siteVariables.textStyles.GTAmericaTrialFont.Bold75,
            fontSize: pxToRem(16),
            lineHeight: pxToRem(17.6),
            letterSpacing: '-0.015em',
        },

        [`& .${svgIconClassName}`]: {
            width: pxToRem(24),
            height: pxToRem(24),
        },
    },

    [theme.screen.laptop]: {
        marginTop: pxToRem(45),

        [`& .${buttonClassName}`]: {
            padding: pxArrayToRem([24, 37.5]),

            [`& .${labelClassName}`]: {
                ...theme.siteVariables.textStyles.GTAmericaTrialFont.Bold75,
                fontSize: pxToRem(15),
                lineHeight: pxToRem(15),
            },
        },
    },
});
